export default __webpack_public_path__ + "static/media/foto2.2ca8c4d8.jpg";